import { css, ThemedCssFunction, DefaultTheme } from 'styled-components'

export const containerBreakpoint = 1736
export const containerMaxWidth = 1576
export const containerLargeMaxWidth = 1920
export const containerContentMaxWidth = 1310

interface Media {
	mobileOnly: ThemedCssFunction<DefaultTheme>
	mobileSmall: ThemedCssFunction<DefaultTheme>
	mobileSmallOnly: ThemedCssFunction<DefaultTheme>
	mobileMedium: ThemedCssFunction<DefaultTheme>
	mobileMediumOnly: ThemedCssFunction<DefaultTheme>
	mobileLarge: ThemedCssFunction<DefaultTheme>
	mobileLargeOnly: ThemedCssFunction<DefaultTheme>
	tablet: ThemedCssFunction<DefaultTheme>
	tabletOnly: ThemedCssFunction<DefaultTheme>
	tabletAndMobileOnly: ThemedCssFunction<DefaultTheme>
	desktopSmall: ThemedCssFunction<DefaultTheme>
	desktopSmallOnly: ThemedCssFunction<DefaultTheme>
	desktopLarge: ThemedCssFunction<DefaultTheme>
	desktopLargeOnly: ThemedCssFunction<DefaultTheme>
	desktopHuge: ThemedCssFunction<DefaultTheme>
	containerContentMaxWidth: ThemedCssFunction<DefaultTheme>
	containerBreakpoint: ThemedCssFunction<DefaultTheme>
	containerMaxWidth: ThemedCssFunction<DefaultTheme>
	containerLargeMaxWidth: ThemedCssFunction<DefaultTheme>
	retina: ThemedCssFunction<DefaultTheme>
}

const sizes: Record<string, number | number[]> = {
	mobileOnly: [0, 767],
	mobileSmall: 320,
	mobileSmallOnly: [320, 375],
	mobileMedium: 375,
	mobileMediumOnly: [375, 424],
	mobileLarge: 425,
	mobileLargeOnly: [425, 767],
	tablet: 768,
	tabletOnly: [768, 1023],
	tabletAndMobileOnly: [0, 1023],
	desktopSmall: 1024,
	desktopSmallOnly: [1024, 1439],
	desktopLarge: 1440,
	desktopLargeOnly: [1440, 1920],
	desktopHuge: 1920,
	containerContentMaxWidth: containerContentMaxWidth,
	containerBreakpoint: containerBreakpoint,
	containerMaxWidth: containerMaxWidth,
	containerLargeMaxWidth: containerLargeMaxWidth,
	retina: 2560,
}

// Iterate through the sizes and create a media template
// eslint-disable-next-line
export const media: Media = Object.keys(sizes).reduce((accumulator: any, label: string) => {
	const v = sizes[label]
	if (Array.isArray(v)) {
		accumulator[label] = (...args: Parameters<typeof css>) => css`
			@media (min-width: ${v[0]}px) and (max-width: ${v[1]}px) {
				${css(...args)}
			}
		`
	} else {
		accumulator[label] = (...args: Parameters<typeof css>) => css`
			@media (min-width: ${v}px) {
				${css(...args)}
			}
		`
	}
	return accumulator
}, {})
